var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('topTab',{ref:"topTab",attrs:{"tab-data":_vm.tabData},on:{"tab-change":_vm.changePages}},[(_vm.activeTab === '1')?_c('logList',{ref:"logList"}):_vm._e(),(_vm.activeTab === '2')?_c('exportLog',{ref:"exportLog"}):_vm._e(),(_vm.activeTab === '3')?_c('logList',{key:"screen-lock",attrs:{"fixed-module":"系统锁屏"}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }